import { ACTION_TYPES, usePublicationsDispatch, usePublicationsState } from "./publications-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import dayjs from "dayjs";
import { IOfficialDiaryPagedRequest } from "models/request/official-diary-paged-request";
import { IPublicationPagedReqeust } from "models/request/publication-paged-request copy";
import { IExportDataRequest } from "models/request/export-data-request";
import { FileDownloadResponse } from "models/response/file-download-response";
export const usePublicationsController = () => {
    const publicationsDispatch = usePublicationsDispatch();
    const { officialDailyRequest, publicationRequest } = usePublicationsState();
    const base64ToBlob = (base64: string, contentType = "") => {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    };
    const handleDownload = (file: FileDownloadResponse) => {
        // // Exemplo de string Base64 (arquivo simples de texto)
        // const base64String = "SGVsbG8sIGNvbnZlcnRlIGVtIGFycnF1aXZvIQ=="; // "Hello, convert in arquivo!"
        // const fileName = "exemplo.txt";
        // const fileType = "text/plain";

        // Criar um Blob a partir da string Base64
        const blob = base64ToBlob(file.source, file.contentType);

        // Criar uma URL para o Blob
        const blobUrl = URL.createObjectURL(blob);

        // Criar um link para download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = file.fileName;

        // Acionar o clique do link
        link.click();

        // Liberar a URL após o download
        URL.revokeObjectURL(blobUrl);
    };

    async function exportData(type: number, format: string) {
        publicationsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: true,
        });
        if (type === 1) {
            const exportDataFile = await MunicipalPortalAAppService.exportData({ ...officialDailyRequest, type, format } as IExportDataRequest);
            handleDownload(exportDataFile);
        } else if (type === 2) {
            const exportDataFile = await MunicipalPortalAAppService.exportData({ ...publicationRequest, type, format } as IExportDataRequest);
            handleDownload(exportDataFile);
        }
        publicationsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: false,
        });
    }
    async function onInit() {
        publicationsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: true,
        });
        let request = { page: 0, pageSize: 20 } as IOfficialDiaryPagedRequest;

        publicationsDispatch({
            type: ACTION_TYPES.setOfficialDailyRequest,
            payload: request,
        });
        publicationsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: true,
        });

        await listOfficialDaily(request);

        const categories = await MunicipalPortalAAppService.listCategoryPublication();

        publicationsDispatch({
            type: ACTION_TYPES.setCategories,
            payload: categories,
        });

        const publishingVehicles = await MunicipalPortalAAppService.listPublisingVehicle();

        publicationsDispatch({
            type: ACTION_TYPES.setPublisingVehicles,
            payload: publishingVehicles,
        });


        publicationsDispatch({
            type: ACTION_TYPES.setLoading,
            payload: false,
        });
    }

    const convertToDate = (date: string | null | undefined): string | null => {
        if (date !== undefined && date !== null) {
            var formattedDate = dayjs(date, "DD/MM/YYYY", true).format("YYYY-MM-DD");
            if (formattedDate.includes("Invalid"))
                return null;
            return formattedDate;
        }

        return null;
    }
    async function listPublication(request: IPublicationPagedReqeust, showLoading: boolean = false) {
        try {
            if (showLoading) {
                publicationsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: true,
                });
            }

            const publication = await MunicipalPortalAAppService.listPublication({ ...request, startDate: convertToDate(request.startDate), endDate: convertToDate(request.endDate) });

            publicationsDispatch({
                type: ACTION_TYPES.setPublicationsResponse,
                payload: publication,
            });

            if (showLoading) {
                publicationsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: false,
                });
            }
        } catch (error) {
            console.log(error);

        }
    }
    async function listOfficialDaily(request: IOfficialDiaryPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                publicationsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: true,
                });
            }

            const officialDaily = await MunicipalPortalAAppService.listOfficialDaily({ ...request, startDate: convertToDate(request.startDate), endDate: convertToDate(request.endDate) });

            publicationsDispatch({
                type: ACTION_TYPES.setOfficialDailyResponse,
                payload: officialDaily,
            });

            if (showLoading) {
                publicationsDispatch({
                    type: ACTION_TYPES.setLoading,
                    payload: false,
                });
            }
        } catch (error) {
            console.log(error);

        }
    }


    const handleOnChange = (e: any, type: number) => {

        if (type === 1) {
            let term = officialDailyRequest?.term;
            let startDate = officialDailyRequest?.startDate;
            let endDate = officialDailyRequest?.endDate;


            if (e.target.name === "text-field-term") {
                term = e.target.value;

                if (term === null || term === undefined || term === "") {
                    (async () => {
                        await listOfficialDaily({ page: 0, pageSize: 20, startDate, endDate } as IOfficialDiaryPagedRequest, true);

                    })()

                }
            }
            if (e.target.name === "text-field-end-date") {
                endDate = e.target.value;

            }
            if (e.target.name === "text-field-start-date") {
                startDate = e.target.value;

            }

            publicationsDispatch({
                type: ACTION_TYPES.setOfficialDailyRequest,
                payload: { ...officialDailyRequest, term, startDate, endDate },
            });
        } else if (type === 2) {
            let term = publicationRequest?.term;
            let startDate = publicationRequest?.startDate;
            let endDate = publicationRequest?.endDate;
            let categoryId = publicationRequest?.categoryId;
            let subcategoryId = publicationRequest?.subcategoryId;
            let publishingVehicleId = publicationRequest?.publishingVehicleId;


            if (e.target.name === "text-field-term") {
                term = e.target.value;

                if (term === null || term === undefined || term === "") {
                    (async () => {
                        await listPublication({ page: 0, pageSize: 20, categoryId, startDate, endDate } as IPublicationPagedReqeust, true);

                    })()

                }
            }
            if (e.target.name === "text-field-end-date") {
                endDate = e.target.value;

            }
            if (e.target.name === "text-field-start-date") {
                startDate = e.target.value;

            }
            if (e.target.name === "text-field-start-date") {
                startDate = e.target.value;

            }
            if (e.target.name === "select-publishing-vehicle-id") {
                publishingVehicleId = e.target.value;

            }

            publicationsDispatch({
                type: ACTION_TYPES.setPublicationRequest,
                payload: { ...publicationRequest, term, startDate, endDate, categoryId, subcategoryId, publishingVehicleId },
            });
        }
    };

    return {
        listOfficialDaily, handleOnChange, onInit, listPublication, exportData
    };
}